import { useMemo } from 'react';
import { useAppSelector, useUserSelector, useDeviceSelector } from 'js/store/hooks';

export const useShowingMode = () => {
    const {
        cookiesConfiguration: { enableCookiesAdmission, enablePresistentCookieLayer },
        dynamicTags
    } = useAppSelector();

    const { role } = useUserSelector();
    const { ua } = useDeviceSelector();

    const bannedUAs = dynamicTags['DTAG_COOKIE_BANNED_UA']?.split('|') || [];
    const isPrerenderBot = bannedUAs.some(bannedUA => ua.includes(bannedUA.toLowerCase()));

    return useMemo(() => {
        if (navigator.cookieEnabled && role !== 'admin') {
            if (!enableCookiesAdmission || isPrerenderBot) {
                return 'hidden';
            } else if (!enablePresistentCookieLayer) {
                return 'common';
            }

            return 'persistent';
        }
    }, [enableCookiesAdmission, enablePresistentCookieLayer, role, isPrerenderBot]);
};
